import React from 'react';
import { List } from 'semantic-ui-react';

import FieldValues from 'components/FieldValues';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import { FertilizerEventProduct } from 'services/fertilizerEvents/types';
import FertilizerEventSummaryProductsList from './components/FertilizerEventSummaryProductsList';
import { FERTILIZER_EVENT_WIZARD_PRODUCT_STEP } from '../../../../constants';

interface Props {
    readOnly: boolean;
}

export default function FertilizerEventSummaryProducts({
    readOnly
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection
            title="Fertilizer product"
            sprayEventWizardStep={FERTILIZER_EVENT_WIZARD_PRODUCT_STEP}
            readOnly={readOnly}
        >
            <List className="summary-list">
                <FieldValues
                    fieldNames={[
                        'fertilizerProducts',
                        'fertilizerEntityIds'
                    ]}
                >
                    {({
                        fertilizerProducts,
                        fertilizerEntityIds
                    }): React.ReactElement => (
                        <React.Fragment>
                            {fertilizerProducts &&
                                fertilizerProducts.map(
                                    (
                                        {
                                            id,
                                            units,
                                            perUnitType
                                        }: FertilizerEventProduct,
                                        index: number
                                    ) => (
                                        <FertilizerEventSummaryProductsList
                                            key={id}
                                            entityIds={
                                                fertilizerEntityIds
                                            }
                                            productId={id}
                                            units={units}
                                            perUnitType={
                                                perUnitType
                                            }
                                            orderIntoTank={
                                                index + 1
                                            }
                                            product={
                                                fertilizerProducts[
                                                index
                                                ]
                                            }
                                        />
                                    )
                                )}
                        </React.Fragment>
                    )}
                </FieldValues>
            </List>
        </WizardEventSummarySection>
    );
}
